import React from "react";
import { ResolutionKeys, StateToShow } from "../types";
import { get_parameters } from "../functions/backend_handlers";
import '../App.css'; // Make sure to import your CSS file

// Import map data
import stateData from "./map_boundaries/stateData";
import countyData from "./map_boundaries/countyData";
import huc2Data from "./map_boundaries/huc2Data";
import huc4Data from "./map_boundaries/huc4Data";
import huc6Data from "./map_boundaries/huc6Data";
import huc8Data from "./map_boundaries/huc8Data";

interface ExportButtonProps {
  polygon_values: { [key: string]: string; };
  resolution: ResolutionKeys;
  dataset: string;
  attribute: string;
  parameters: StateToShow;
  year: number | undefined;
  className?: string; // Optional class name for styling
  disabled? : boolean;
  is_overlay? : string
}

const map_geopolygon = {
  state: stateData,
  county: countyData,
  huc2: huc2Data,
  huc4: huc4Data,
  huc6: huc6Data,
  huc8: huc8Data,
  overlay: undefined
};

const ExportButton: React.FC<ExportButtonProps> = ({
  polygon_values,
  resolution,
  dataset,
  attribute,
  parameters,
  year,
  className,
  disabled = false,
  is_overlay = "False"
}) => {


  if(is_overlay == "True" || map_geopolygon[resolution] == undefined) return

  let data: GeoJSON.FeatureCollection = { ...map_geopolygon[resolution] };

  const current_parameter_text = get_parameters(parameters) === undefined ? "" : `-${get_parameters(parameters)}`;
  const current_year_text = year === undefined ? "" : `-${year}`;
  const filename_string = `${dataset}-${attribute}${current_parameter_text}${current_year_text}.json`;

  for (let i = 0; i < data.features.length; i++) {
    const feature = data.features[i]; // Store the feature in a variable
    const featureId = data.features[i].id; // Store the ID

    if (feature.properties !== null && featureId !== undefined) {
      feature.properties.value = polygon_values[featureId];
    }
  }

  const downloadJson = () => {
    // Convert GeoJSON to JSON
    const jsonData = data;

    // Create a Blob object from the JSON data
    const blob = new Blob([JSON.stringify(jsonData, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);

    // Create a temporary download link
    const link = document.createElement('a');
    link.href = url;
    link.download = filename_string; // Set the filename for the JSON file

    // Programmatically click the link to trigger the download
    link.click();

    // Clean up by revoking the object URL
    URL.revokeObjectURL(url);
  };

  return (
    <button
      onClick={downloadJson}
      className={disabled ? (`${className} disabled` || "export-map-button disabled")  : (className || "export-map-button")}
    >
      Export Map
    </button>
  );
};

export default ExportButton;